import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { SelectedValue, TaskUpdater } from '../../shared/model';
import { OfbizForm } from '@urbannex/ofbiz-forms';
import { TaskStoreService } from '../task-store.service';
import { Subject, takeUntil, takeWhile } from 'rxjs';

@Component({
  selector: 'ubs-task-updater',
  templateUrl: './task-updater.component.html',
  styleUrls: ['./task-updater.component.scss']
})
export class TaskUpdaterComponent implements OnInit, OnDestroy{
  @Input() updater:TaskUpdater;
  @Input() parameters:any;
  updaterForm:OfbizForm;
  addContainerTitle:string;
  appContext:string;
  selectedValue:SelectedValue;
  lookupFieldResult:any;

  readonly activeStepIndex$ = this.taskStore.activeStepIndex$;
  readonly selectedRow$ = this.taskStore.selectedRow$;
  readonly destroy$ = new Subject<void>()

  constructor(private taskStore: TaskStoreService) {}
  

  ngOnInit():void{
    this.activeStepIndex$.subscribe(index => {
      console.log("Active Step Index",index)
      if(this.updater != null && this.updater != undefined){
        let activeUpdate = this.updater.updateActions[index];
        this.updaterForm = activeUpdate.updateForm;
        this.addContainerTitle = activeUpdate.title;
        this.taskStore.context$.subscribe(context => {
          console.log("Active Context",context,"parameters: ",this.parameters)
        })
      }
    })
    this.selectedRow$.pipe(takeUntil(this.destroy$)).subscribe(row => {
      console.log(row)
      if(row.length > 0){
        let contextObj = {};
        row.forEach((obj) => {
          Object.entries(obj).forEach(([key,val]) => {
            contextObj[key] = val;
          })
        });
        this.taskStore.updateContext(contextObj);
        
        //this.taskStore.activeStepIndex$
        
        this.taskStore.goNext();
        this.selectedValue = this.updateSelectedValue(contextObj)
      }
    })
  }
  
  
  /* ngOnChanges(changes: SimpleChanges): void {
    if(changes["updater"]){
      console.log(this.updater)
      this.updater.updateActions.forEach(action => {
        if(action.isDefault){
          this.updaterForm = action.updateForm;
          this.addContainerTitle = action.title;
        }
      })
    }
  } */
  openDialogContainer(e){

  }

  handleFormSubmit(e){
    console.log(e)
  }

  refreshRelatedLists(e){

  }

  submitResult(e){
    if(e != null && e != undefined){
      if(e["value"] != null && e["value"] != undefined){
        console.log(e["value"])
        //console.log({parameters:this.parameters})
        this.taskStore.updateContext(e["value"]);
        
        //this.taskStore.activeStepIndex$
        
        this.taskStore.goNext();
        this.selectedValue = this.updateSelectedValue(e["value"])
      }
    }
  }

  updateSelectedValue(context:any):SelectedValue{
    const excludeFields = ['successMessage', 'responseMessage','errorMessage']; // List of fields to exclude
    this.parameters = Object.fromEntries(
      Object.entries(context).filter(([key]) => !excludeFields.includes(key))
    );
    let selectedValue = {
      type: 'edit', // provide appropriate type value
      data: {
        formData: {
          formName: this.updaterForm.formName,
          formLocation: this.updaterForm.formLocation,
        },
        parameters:this.parameters
      }  // provide appropriate data value
      
    }
    this.activeStepIndex$.subscribe(index => {
      console.log(index);
    })

    return selectedValue;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  
}
